import { Routes } from '@angular/router';
import { Route404Component } from '@app/route404/route404.component';
import { LogoutComponent } from '@app/auth/logout.component';
import { LoginComponent } from '@app/auth/login.component';
var ɵ0 = {
    title: 'Dashboard',
    locationSelector: true,
}, ɵ1 = {
    title: 'Notifications',
    locationSelector: true,
}, ɵ2 = {
    title: 'Settings',
    locationSelector: true,
}, ɵ3 = {
    title: 'Find a Local Pro',
    locationSelector: true,
}, ɵ4 = {
    title: 'Event Review',
    locationSelector: true,
};
export var routes = [
    {
        path: 'dashboard',
        loadChildren: './detailed/detailed.module#DetailedModule',
        data: ɵ0,
    },
    {
        path: 'notifications',
        loadChildren: './notifications/notifications.module#NotificationsModule',
        data: ɵ1,
    },
    {
        path: 'settings',
        loadChildren: './settings/settings.module#SettingsModule',
        data: ɵ2,
    },
    {
        path: 'local-pro',
        loadChildren: './angi/angi.module#AngiModule',
        data: ɵ3,
    },
    {
        path: 'events',
        loadChildren: './event-review/event-review.module#EventReviewModule',
        data: ɵ4,
    },
    {
        path: 'logout',
        component: LogoutComponent,
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: '',
        component: LoginComponent,
    },
    {
        path: '**',
        component: Route404Component,
    },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
